<template>
  <!-- 工作台 -->
  <el-container class="home-container">
    <el-header class="homeHeader">
      <div>
        <el-image :src="imgUrl"></el-image>
      </div>
      <div>
        <!-- <span @click="HrefClick" style="margin-right:1rem;">切换旧版</span> -->
        <span @click="HrefClick"  style="margin-right:1rem;display:flex;font-size: 14px; align-items: center;">
            <p style="margin:0">新版</p>
            <p  style="margin:0 3px;">/</p>
            <p style="color:#246DEB;margin:0">切换旧版</p>
        </span>
        <span>
          <img src="../images/scenic/admin.png" alt srcset />
        </span>
        <span style="margin-right:0.5rem; font-size: 1.4rem;">{{name}} {{DistributorID}}</span>
        <span style="font-size: 1.4rem;" @click="outFn">退出</span>
      </div>
    </el-header>
    <el-container>
      <el-aside width="260px">
        <el-menu
          :collapse-transition="false"
          background-color="#2A354D"
          text-color="#fff"
          active-text-color="#fff"
          router
        >
          <template v-for="v in menu">
            <template v-if="v.childrens">
              <el-submenu :index="v.path">
                <template slot="title">
                  <img
                    :src="v.icon"
                    alt
                    srcset
                    style=" width:14px;height:14px; color: white;margin-right:5px"
                  />
                  <span slot="title">{{ v.title }}</span>
                </template>
                <el-menu-item-group>
                  <el-menu-item
                    v-for="vv in v.childrens"
                    :index="'/' + vv.path"
                    :key="vv.id"
                  >{{ vv.title }}</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item :index="'/'+v.path">
                <img
                  :src="v.icon"
                  alt
                  srcset
                  style=" width:14px;height:14px; color: white;margin-right:5px"
                />
                <span slot="title">{{ v.title }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { distributorLogout} from '@/request/login.js'
import {getDistributorDetail } from "@/request/distributor.js"
export default {
  data() {
    return {
      imgUrl: require("../images/scenic/logo.png"),
      // 分销商菜单
      fxMenu: [
        {
          id: 1,
          title: "工作台",
          path: "fxWorke",
          icon: require("../images/distributor/gzt.png")
        },
        {
          id: 2,
          title: "产品管理",
          path: "product",
          icon: require("../images/distributor/jq.png"),
          children: [
            {
              id: 2 - 1,
              title: "产品列表",
              path: "proList"
            },
            {
              id: 2 - 2,
              title: "预订单列表",
              path: "advanceList"
            }
          ]
        },
        {
          id: 3,
          title: "二级分销商管理",
          path: "ejFxs",
          icon: require("../images/distributor/fx2.png"),
          children: [
            {
              id:3 - 1,
              title: "我的分销商",
              path: "ejFxs"
            },
          ]
        },
        {
          id: 4,
          title: "景区管理",
          path: "FxsScenicMange",
          icon: require("../images/distributor/jq.png"),
          children: [
            {
              id: 4 - 1,
              title: "景区列表",
              path: "FxsScenicMange"
            },
          ]
        },
        // {
        //   id: 5,
        //   title: "营销管理",
        //   path: "market",
        //   icon: require("../images/distributor/yxgl.png"),
        //   children: [
        //     {
        //       id: 2 - 1,
        //       title: "景区设置",
        //       path: "scenicSet"
        //     },
        //     {
        //       id: 2 - 2,
        //       title: "权限管理",
        //       path: "rightMan"
        //     },
        //     {
        //       id: 2 - 3,
        //       title: "合作方式",
        //       path: "cooperation"
        //     },
        //     {
        //       id: 2 - 4,
        //       title: "供应商设置",
        //       path: "providerSet"
        //     }
        //   ]
        // },
        {
          id: 6,
          title: "财务报表",
          path: "finance",
          icon: require("../images/distributor/cw.png"),
          children: [
            {
              id: 2 - 1,
              title: "订单查询",
              path: "orderMang"
            },
            // {
            //   id: 2 - 2,
            //   title: "销售订单",
            //   path: "sellOrder"
            // },
            {
              id: 2 - 3,
              title: "销售统计",
              path: "sellSta"
            },
            // {
            //   id: 2 - 4,
            //   title: "预定订单",
            //   path: "reserveOrder"
            // },
            {
              id: 2 - 5,
              title: "发票列表审核",
              path: "invoiceExamine"
            },
            {
              id: 2 - 6,
              title: "打款列表",
              path: "PayList"
            },
            {
              id: 2 - 7,
              title: "发票配置",
              path: "invoiceSet"
            },
            {
              id: 2 - 8,
              title: "费用详情",
              path: "costInfo"
            }
          ]
        },

        {
          id: 7,
          title: "系统设置",
          path: "system",
          icon: require("../images/distributor/xtsz.png"),
          children: [
            {
              id: 2 - 1,
              title: "分销商设置",
              path: "fxSet"
            },
            {
              id: 2 - 2,
              title: "管理员设置",
              path: "personSet"
            }
          ]
        }
      ],
      name:"",
      DistributorID:''
    };
  },
  created(){
    if(this.$route.query.data){
      let datas = JSON.parse(this.$route.query.data)
      this.navList = datas.permission;
      window.sessionStorage.setItem("menue", JSON.stringify(this.navList));
      window.sessionStorage.setItem("Token", datas.token);
      window.sessionStorage.setItem('path', '/login')
    }
    let data = {
      token:window.sessionStorage.getItem('Token'),
    }
    getDistributorDetail(data).then(res=>{
      if(res.data.status=='ok'){
        this.DistributorID = res.data.result.DistributorID
        this.name = res.data.result.Name
        window.sessionStorage.setItem("user_code",res.data.result.UserCode);
        window.sessionStorage.setItem('diskey', res.data.result.Diskey)
      }
    })
    let Mmen = this.fxMenu
    let menu = JSON.parse(window.sessionStorage.getItem('menue'))
    let arr = []
    Mmen.map(item=>{
      menu.map(itm=>{
        if(item.title==itm.title){
          arr.push(item)
        }
      })
      if(item.title=='工作台'){
          arr.push(item)
        }
    })
    arr.map(item=>{
      item.childrens = []
      menu.map(itm=>{
        if(item.title==itm.title){
          if(item.children){
            item.children.map(items=>{
              itm.son.map(itms=>{
                if(itms.title==items.title){
                  item.childrens.push(items)
                }
              })
            })
          }
        }
      })
    })
    arr.map(item=>{
      if(item.title=='财务报表'){
        item.childrens.push({
          id:2-3,
          path:'oring',
          title:'批量订单'
        })
      }
    })
    this.menu = arr
    this.menu.map(item=>{
      if(item.childrens.length==0){
        delete item.childrens
      }
    })
  },
  methods: {
    HrefClick(){
      // let href = 'http://home.softykt.net/'
      let href = "http://home.softykt.net/"
      window.open(href)
    },
    // 点击退出
    outFn() {
      let data = {
        token:window.sessionStorage.getItem('Token'),
      }
      distributorLogout(data).then(res=>{
        if(res.data.status=='ok'){
          this.$message.success('退出登录')
          window.sessionStorage.removeItem('Token');
          window.sessionStorage.removeItem('menue');
          this.$router.push("/login");
        }
      })
    }
  }
};
</script>

<style lang='less' scoped>
.active {
  background-color: rgba(36, 109, 235, 0.4);
}
//设置了行高和字体大小、高度颜色
/deep/.el-menu-item {
  font-size: 14px;
  height: 52px;
  line-height: 52px;
  color: #666666;
  transition: none !important;
}
//子节点选中样式(前面只有一级，后面子级)
/deep/.el-menu-item.is-active,
.el-submenu .el-menu-item.is-active {
  background-color: rgba(36, 109, 235, 0.4) !important;
}
.home-container {
  height: 100vh;
}
.el-header {
  background-color: #001529;
  color: white;
}
.homeHeader {
  display: flex;
  justify-content: space-between;
  > div:nth-child(1) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > div:nth-child(2) {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    > span:nth-child(1) {
      .img {
        width: 12px;
        height: 12px;
      }
    }
    > span:nth-child(2) {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      /* identical to box height */
      color: #ffffff;
      margin: 0 19px 0 8px;
    }
    > span:nth-child(3) {
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 17px;
      /* identical to box height */

      color: #ffffff;
    }
  }
}

.el-aside {
  background-color: #2a354d;
}
.el-main {
  background: #e5e5e5;
}

</style>